import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export const getConversionReportType = async campaignId => {
  const query = `query ($campaignId:ID!) {
    campaign(id:$campaignId) {
      name
      type
      subtype
      metrics {
        nodes {
          label
          name
          isPrimary
        }
      }
      conversionsCount
      paidConversionsCount
      conversionReportType
      country {
        code
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}

export const updateConversionReportType = async ({
  campaignId,
  conversionReportType,
}) => {
  const query = `mutation updateCampaign(
    $input: UpdateCampaignInput
  ) {
    updateCampaign(
      input: $input,
    ) {
      campaign {
        conversionReportType
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    input: {
      campaignId,
      conversionReportType,
    },
  })
}

export const deleteConversions = async ({
  campaignId,
  includePaid,
  includeUnPaid,
  conversionLogId = undefined,
}) => {
  const query = `mutation deleteConversions(
    $input: DeleteConversionsInput!
  ) {
    deleteConversions(
      input: $input,
    ) {
      count
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    input: {
      campaignId,
      includePaid,
      includeUnPaid,
      conversionLogId,
    },
  })
}

export const getConversionLogs = `
  query (
    $campaignId: ID!,
    $first: Int,
    $after: String,
    $skip: Int
  ) {
    conversionLogs(
      campaignId: $campaignId,
      first: $first,
      after: $after,
      skip: $skip
    ) {
      edges {
        cursor,
        node {
          id,
          campaignId,
          reportType,
          fileName,
          status,
          uploaderName,
          deleterNameOfPaid,
          deleterNameOfUnpaid,
          flyersCount,
          conversionsCount,
          currentConversionsCount,
          conversionsCountFPM,
          paidConversionsCountFPM,
          timestamp,
          isLatest
        }
      },
      totalCount,
      pageInfo {
        hasNextPage,
        endCursor
      }
    }
  }
`

export const getStatistics = `
  query (
    $campaignId: ID!
  ) {
    conversionsStatistics(
      campaignId: $campaignId
    ) {
      totalUploads,
      totalFlyerCodesCount,
      totalConversionsCount,
      metricsInfo {
        metricName,
        conversionsCount
      },
      firstConversionDate,
      lastConversionDate,
    }
  }
`

export const getMetrics = `
  query ($campaignId:ID!) {
    campaign(id:$campaignId) {
      metrics {
        nodes {
          name
          label
          isPrimary
        }
      }
    }
  }
`

export const downloadConversions = `
  query(
    $campaignId: ID!,
    $conversionLogId: ID!,
    $reportType: String,
    $first: Int,
    $skip: Int
  ) {
    downloadConversions(
      campaignId: $campaignId,
      conversionLogId: $conversionLogId,
      reportType: $reportType,
      first: $first,
      skip: $skip
    ) {
      edges {
        cursor,
        node
      },
      totalCount,
      pageInfo {
        hasNextPage
      }
    }
  }
`
